<template>
  <div class="tableItemEdit"
       @click="itemClick"
       @mouseenter="mouseenter"
       @mouseleave="editShow = false">
    <div class="textCont-label">{{name}}：</div>
    <div slot="content"
         class="textCont-value"
         v-if="type=='detail'">{{ content }}</div>
    <div class="mainCont"
         v-else-if="type=='edit'">
      <el-input v-model="content"
                v-if="itemList.length == 0"
                size="mini"
                focus
                @keyup.enter.native="itemBlur"
                @blur="itemBlur"
                ref="contentInput">
      </el-input>
      <el-select v-model="content"
                 v-else-if="itemList.length > 0"
                 clearable
                 filterable
                 @change="itemBlur"
                 @visible-change="visibleChange"
                 size="mini"
                 ref="contentInput">
        <el-option v-for="item in itemList"
                   :key="item[prop.value]"
                   :label="item[prop.label]"
                   :value="item[prop.value]"></el-option>
      </el-select>
    </div>
    <el-button size="mini"
               icon="el-icon-edit"
               v-if="editShow && type=='detail'"
               type="text"
               @click="itemClick"
               class="editBtn"></el-button>
  </div>
</template>
<script>
import { cmofferApi } from "@/http/cmofferApi.js";
import { hideLoading } from "@/common/plugins/loading";
export default {
  data() {
    return {
      type: "detail",
      editShow: false,
      first_content: "",
    };
  },
  methods: {
    itemClick() {
      this.type = "edit";
      this.first_content = this.content;
      this.$nextTick(() => {
        this.$refs["contentInput"].focus();
      });
    },
    itemBlur() {
      hideLoading();
      if (this.content !== this.first_content) {
        let obj = {};
        obj[this.keyName] = this.content;
        obj.rank = this.rank;
        obj.id = this.itemId;
        this.type = "detail";
        cmofferApi[this.funcName](
          {
            ...obj,
          },
          "post",
          this.itemId
        ).then((res) => {
          if (res) {
            this.$emit("updateItem", obj);
            this.$parent.$parent.$parent[this.parentFunc]();
          } else {
            this.content = "";
          }
        });
      } else {
        this.type = "detail";
      }
    },
    mouseenter() {
      this.editShow = true;
    },
    visibleChange(val) {
      if (val == false) {
        this.type = "detail";
      }
    },
  },
  props: {
    content: {
      type: String,
      default: () => {
        return "";
      },
    },
    keyName: {
      type: String,
    },
    name: {
      type: String,
    },
    funcName: String,
    itemId: Number,
    prop: {
      type: Object,
      default: () => {
        return {
          value: "value",
          label: "label",
        };
      },
    },
    itemList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    parentFunc: {
      type: String,
    },
    rank: String
  },
};
</script>
<style lang="scss" scoped>
.tableItemEdit {
  width: 100%;
  cursor: default;
  display: flex;
  height: 28px;
  line-height: 28px;
  .editBtn {
    margin: 0 4px;
  }
  .textCont-value {
    overflow: hidden;
  }
}
</style>
